
  import VueApexCharts from "vue-apexcharts";
  import { Component, Vue,Watch } from 'vue-property-decorator';
  import axios from 'axios';
  @Component({
    components: {
      apexchart: VueApexCharts,
    },
    data() {
  return {
    isDailyErrorCountLoading: false,
    isTopTenErrorCountLoading: false,
    isTopTwentyLoading: false,
    isDailyUserCountLoading: false,
  }
}
  })
  export default class UserStatics extends Vue {
    public bardateFrom: Date | null = null;
    public bardateTo: Date | null = null;
    public ErrordateFrom: Date | null = null;
    public ErrordateTo: Date | null = null;
    public E10dateFrom: Date | null = null;
    public E10dateTo: Date | null = null;
    public isBusy = false;
    public IsMounted=false;
    public dateFrom: Date | null = null;
    public dateTo: Date | null = null;
    @Watch('ErrordateFrom')
    public onErrorDateFromChange(newVal: Date | null) {
      if (newVal) {      
        const newDate = new Date(newVal);
        newDate.setDate(newDate.getDate() + 29);
        this.ErrordateTo = newDate;
  
        // Call loadDailyUserCount whenever dateFrom changes
        this.loadDailyErrorCount();
      }
    }
    @Watch('E10dateFrom')
    public onE10DateFromChange(newVal: Date | null) {
      if (newVal) {      
        const newDate = new Date(newVal);
        newDate.setDate(newDate.getDate() + 1);
        this.E10dateTo = newDate;
  
        // Call loadDailyUserCount whenever dateFrom changes
        this.loadTop10ErrorCount();
      }
    }
    @Watch('bardateFrom')
    public onbarDateFromChange(newVal: Date | null) {
      if (newVal) {      
        const newDate = new Date(newVal);
        newDate.setDate(newDate.getDate() + 1);
        this.bardateTo = newDate;
  
        // Call loadDailyUserCount whenever dateFrom changes
        this.loadDailyUsedFeatureCount();
      }
    }
    @Watch('dateFrom')
  public onDateFromChange(newVal: Date | null) {
    if (newVal) {      
      const newDate = new Date(newVal);
      newDate.setDate(newDate.getDate() + 29);
      this.dateTo = newDate;

      // Call loadDailyUserCount whenever dateFrom changes
      this.loadDailyUserCount();
    }
  }
    public ErrorDailySeries = [
      {
        name: 'Error Count',
        data: [],
      },
    ]; 
    public DailySeries = [
    {
      name: 'User Count',
      data: [],
    },
  ];   
  public chartOptions = {
    chart: {
      height: '250px',      
      type: 'line',
      toolbar: {
            show: true, // Display the toolbar
            tools: {
              download: true, // Enable only the download button
              selection: false, // Disable selection tool
              zoom: false, // Disable zoom
              zoomin: false, // Disable zoom in
              zoomout: false, // Disable zoom out
              pan: false, // Disable pan
              reset: false, // Disable reset zoom
            },
          },
    },
    stroke: {
      width: 2,
      curve: 'smooth',
    },
    xaxis: {
      categories:[],// Array.from({ length: 31 }, (_, i) => i + 1),
      title: {
        text: 'Date', // X-axis label (horizontal)
      },
    },
    yaxis: {
      title: {
        text: 'User Count', // Y-axis label (vertical)
      },
    },
    title: {
      text: '',
      align: 'center',
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
    },
  };
  public E10ChartSeries = [
      {
        name: 'Count',
        data: [],
      },
    ];
    public E10chartOptions = {
      chart: {
        height: '300px',      
        type: 'bar',
        toolbar: {
              show: true, // Display the toolbar
              tools: {
                download: true, // Enable only the download button
                selection: false, // Disable selection tool
                zoom: false, // Disable zoom
                zoomin: false, // Disable zoom in
                zoomout: false, // Disable zoom out
                pan: false, // Disable pan
                reset: false, // Disable reset zoom
              },
            },
      },
      plotOptions: {
            bar: {
                barHeight: '100%',                
                horizontal: true,
                dataLabels: {
                    position: 'bottom'
                },
                distributed: true, 
            }
          },
          colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
          ],
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      yaxis: {
          labels: {
            show: false
          }
        },
      xaxis: {       
        categories:[],//['Add Row Header', 'Add Legend', 'Set EY Layout', 'Slide Library', 'Gauge', 'Add Shape', 'Slide Search',
             //'Undo Comments', 'Rotate Gauge', 'Disclaimer'],// Array.from({ length: 31 }, (_, i) => i + 1),      
             labels: {
      show: false,  // Hides the x-axis bottom labels
    },
            },
      title: {
        text: '',
        align: 'center',
        floating:true
      },
      dataLabels: {
        enabled: true, 
        textAnchor: 'start',    
        style: {
            colors: ['#fff']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          }, 
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
      },      
    };
    public BarSeries = [
      {
        name: 'Count',
        data: [],//[400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],//[90, 160, 140, 190, 280, 210, 350, 300, 320, 310, 400, 500],
      },
    ];
    public barchartOptions = {
      chart: {
        height: '500px',      
        type: 'bar',
        toolbar: {
              show: true, // Display the toolbar
              tools: {
                download: true, // Enable only the download button
                selection: false, // Disable selection tool
                zoom: false, // Disable zoom
                zoomin: false, // Disable zoom in
                zoomout: false, // Disable zoom out
                pan: false, // Disable pan
                reset: false, // Disable reset zoom
              },
            },
      },
      plotOptions: {
            bar: {
                barHeight: '100%',                
                horizontal: true,
                dataLabels: {
                    position: 'bottom'
                },
                distributed: true, 
                barPadding : 10
            }
          },
          colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
          ],
      stroke: {
        width: 1,
        colors: ['#fff'],        
      },
      yaxis: {
          labels: {
            show: false
          }
        },
      xaxis: {       
        categories:[],//['Add Row Header', 'Add Legend', 'Set EY Layout', 'Slide Library', 'Gauge', 'Add Shape', 'Slide Search',
             //'Undo Comments', 'Rotate Gauge', 'Disclaimer'],// Array.from({ length: 31 }, (_, i) => i + 1),      
             labels: {
      show: false,  // Hides the x-axis bottom labels
    },
            },
      title: {
        text: '',
        align: 'center',
        floating:true
      },
      dataLabels: {
        enabled: true, 
        textAnchor: 'start',    
        style: {
            colors: ['#fff']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          }, 
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
      },      
    };
  
    public ErrorchartOptions = {
      chart: {
        height: '300px',      
        type: 'line',
        toolbar: {
              show: true, // Display the toolbar
              tools: {
                download: true, // Enable only the download button
                selection: false, // Disable selection tool
                zoom: false, // Disable zoom
                zoomin: false, // Disable zoom in
                zoomout: false, // Disable zoom out
                pan: false, // Disable pan
                reset: false, // Disable reset zoom
              },
            },
      },
      stroke: {
        width: 2,
        curve: 'smooth',
      },
      xaxis: {
        categories:[],// Array.from({ length: 31 }, (_, i) => i + 1),
        title: {
          text: 'Date', // X-axis label (horizontal)
        },
      },
      yaxis: {
        title: {
          text: 'Error Count', // Y-axis label (vertical)
        },
      },
      title: {
        text: '',
        align: 'center',
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
      },
    };
  
    
    public mounted() {          
      const today = new Date();
      const Lastmonthdate = new Date();
      const LastOneyearbackdate = new Date();
      Lastmonthdate.setDate(Lastmonthdate.getDate() - 29);
      LastOneyearbackdate.setDate(LastOneyearbackdate.getDate() - 365);
      this.dateFrom = this.formatDate(Lastmonthdate);
      const nextMonth = new Date(Lastmonthdate);
      nextMonth.setDate(Lastmonthdate.getDate() + 29);
      this.dateTo = nextMonth;
      this.bardateFrom = this.formatDate(today);
      const nextdaybar = new Date(today);
      nextdaybar.setDate(today.getDate() + 1);
      this.bardateTo = nextdaybar;
  
      this.ErrordateFrom = this.formatDate(Lastmonthdate);
  
      const ErrornextMonth = new Date(Lastmonthdate);
      ErrornextMonth.setDate(Lastmonthdate.getDate() + 29);
      this.ErrordateTo = ErrornextMonth;

      this.E10dateFrom = this.formatDate(today);
  
      const E10nextMonth = new Date(today);
      E10nextMonth.setDate(Lastmonthdate.getDate() + 1);
      this.E10dateTo = E10nextMonth;
     //this.loadDailyErrorCount();
     // this.loadDailyUsedFeatureCount();
     // this.loadTop10ErrorCount();
    }
    public loadTop10ErrorCount(){
    if (!this.E10dateFrom || !this.E10dateTo) {
      return;
    }
    const fromDate = this.E10dateFrom;
    const toDate =this.formatDate(this.E10dateTo);
    this.isBusy = true;
    this.isTopTenErrorCountLoading = true;
    axios.get('/api/v4/Logs/Top10Error/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(      
      (response: any) => {                
        const d = response.data[0] || [];                    
        //this.E10ChartSeries =Object.values(d);
        //this.E10ChartOptions.labels =Object.keys(d);        
        //this.E10ChartOptions = Object.assign({}, this.E10ChartOptions);
    var val = Object.values(d);
         var ky = Object.keys(d);      
          this.$set( this.E10ChartSeries[0],'data',Object.values(d));        
      this.$set(this.E10chartOptions.xaxis, 'categories',Object.keys(d));
     this.E10chartOptions = Object.assign({}, this.E10chartOptions);
    this.isBusy = false;
      },
      (error) => {
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isTopTenErrorCountLoading = false;
    });
    
  }
    public loadDailyErrorCount(){
      if (!this.ErrordateFrom || !this.ErrordateTo) {
        return;
      }
      const fromDate = this.ErrordateFrom;
      const toDate =this.formatDate(this.ErrordateTo);
      this.isBusy = true;
      this.isDailyErrorCountLoading = true;
      axios.get('/api/v4/Logs/DailyErrorCount/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(       
        (response: any) => {        
          const d = response.data[0] || [];
          const keysdata = Object.keys(d);       
          this.$set( this.ErrorDailySeries[0],'data',Object.values(d));
          const dayLabels = keysdata.map(date => {
        const d = new Date(date); // Convert string to Date object
        return d.getDate().toString(); // Extract day as string
      });
      this.$set(this.ErrorchartOptions.xaxis, 'categories',dayLabels);
      this.ErrorchartOptions = Object.assign({}, this.ErrorchartOptions);
      this.isBusy = false;
        },
        (error) => {
        
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isDailyErrorCountLoading = false;
    });
    
      
    }
    public loadDailyUsedFeatureCount(){
      if (!this.bardateFrom || !this.bardateTo) {
        return;
      }
      const fromDate = this.bardateFrom;
      const toDate =this.formatDate(this.bardateTo);
      this.isBusy = true;
      this.isTopTwentyLoading = true;
      axios.get('/api/v4/Logs/UsersbyFeature/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(
        (response: any) => {        
          //debugger
          const d = response.data[0] || [];            
         var val = Object.values(d);
         var ky = Object.keys(d);      
          this.$set( this.BarSeries[0],'data',Object.values(d));        
      this.$set(this.barchartOptions.xaxis, 'categories',Object.keys(d));
     this.barchartOptions = Object.assign({}, this.barchartOptions);
      this.isBusy = false;
        },
        (error) => {
        
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isTopTwentyLoading = false;
    });
      
    }
    public loadDailyUserCount(){
    if (!this.dateFrom || !this.dateTo) {
      return;
    }
    const fromDate = this.dateFrom;
    const toDate =this.formatDate(this.dateTo);
    this.isBusy = true;
    this.isDailyUserCountLoading = true;
    axios.get('/api/v4/Logs/GetDailyRegisteredUserCounts/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(      
      (response: any) => {        
        const d = response.data[0] || [];
        const keysdata = Object.keys(d);       
        this.$set( this.DailySeries[0],'data',Object.values(d));
        const dayLabels = keysdata.map(date => {
      const d = new Date(date); // Convert string to Date object
      return d.getDate().toString(); // Extract day as string
    });
    this.$set(this.chartOptions.xaxis, 'categories',dayLabels);
    this.chartOptions = Object.assign({}, this.chartOptions);
    this.isBusy = false;
      },
      (error) => {
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isDailyUserCountLoading = false;
    });
    
    
  }
    
    public formatDate(date: Date | null): string | null {
    if (date instanceof Date && !isNaN(date.getTime())) {
      return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
    }
    return null;
  }
  public getFirstDateOfMonth(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      return `${year}-${month}-01`; // Return in YYYY-MM-DD format
    }
  
    public getLastDateOfMonth(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const lastDay = new Date(year, date.getMonth() + 1, 0).getDate(); // Get the last day of the month
      return `${year}-${month}-${lastDay}`; // Return in YYYY-MM-DD format
    }
    
  }
  